
import PointFocalCreate from "@/pages/administrer/focal/PointFocalCreate.vue";
import PointFocal from "@/pages/administrer/focal/List.vue";
import ShowPointFocal from "@/pages/administrer/focal/ShowPointFocal.vue";

export default [{
    path: 'point-focal/create',
    meta: { permissions: ["create_user"] },
    name: "AdminPointFocalAdd",
    component: PointFocalCreate,
},
{
    path: 'point-focal/:id/show',
    meta: { permissions: ["view_any_user"] },
    name: "AdminPointFocalShow",
    component: ShowPointFocal,
},
{
    path: 'point-focal',
    meta: { permissions: ["view_user"] },
    name: "AdminPointFocal",
    component: PointFocal,

}]